import {Data} from './data';
import React from 'react';
import {MdChevronLeft,MdChevronRight} from 'react-icons/md';
const Projects = () =>{

     const slideLeft=() =>{
        var slider = document.getElementById('slider');
        slider.scrollLeft = slider.scrollLeft - 500;
     }
     const slideRight=() =>{
        var slider = document.getElementById('slider');
        slider.scrollLeft = slider.scrollLeft + 500;
     }
    return(
        <section className='mt-8 hid' id='projects'>
            <h1 className="header">MY PROJECTS</h1>
            <div className=" flex  items-center">
                <MdChevronLeft onClick={slideLeft} size={40} 
                className=' rounded-full opacity-50 hover:opacity-100 cursor-pointer z-10 '
                />
                <div id="slider" className="w-full snap-mandatory snap-x h-60 mt-2 scrollbar-hide overflow-x-scroll scroll whitespace-nowrap scroll-smooth">
                   
                {Data.map((item)=>(
                    <div className="card">
                        <img className="image" src={item.img} alt="/" />
                       <p className="paraga">{item.description}</p>
                       <div className="btns">
                       <a className="a" href={item.livelink} target="_blank">live <span className='hidden md:inline'>preview</span> </a>
                       <a className="a" href={item.gitlink} target="_blank">git<span className='hidden md:inline'>hub</span></a>
                       
                       </div>
                    </div>
                     ))}
               
                   
                </div>
                <MdChevronRight onClick={slideRight} size={40}
                className=' rounded-full opacity-50 hover:opacity-100 cursor-pointer z-10  group-hover:block'
                />

            </div>
        </section>
    )
}
export default Projects;